<template>
  <vue-slick-carousel v-bind="carouselSettings">
    <slot></slot>
  </vue-slick-carousel>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "CarouselFrame",
  components: {
    VueSlickCarousel
  },
  props: ["carouselSettings"]
};
</script>
